import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

import locale from "locale";
import api from "api";
import routes from "config/routes";

import Form from "../Form";
import useNavStore from "stores/useNavStore";
import useFormState from "../Form/useFormState";

export default () => {
  /**
   * Hooks
   */
  const { id } = useParams<{ id: string }>();

  const nativeNavigate = useNavigate();
  const navigate = useNavStore((state) => state.navigate);

  const { name, description, isActive, setForm } = useFormState();

  const { data, error } = useQuery({
    queryKey: [api.department.queryKey, id],
    queryFn: () => api.department.getById(id!),
    enabled: !!id && !!navigate,
  });

  const queryClient = useQueryClient();

  const mutation = useMutation(api.department.update, {
    onSuccess: () => {
      queryClient.invalidateQueries(api.department.queryKey);
      queryClient.invalidateQueries([api.department.queryKey, id]);

      const message = locale.en.toastMessages.updateSuccess.replace(
        "{{ 1 }}",
        "Department"
      );
      toast.success(message);

      navigate!(routes.settings.routes!.department);
    },
  });

  useEffect(() => {
    if (data) {
      setForm("name", data.name);
      setForm("description", data.description);
      setForm("isActive", data.isActive);
    }
  }, [data]);

  useEffect(() => {
    if (error && navigate) {
      const route = routes.error;
      navigate(route);
    }
  }, [error, navigate]);

  /**
   * Not hook
   */
  const handleSubmit = () => {
    if (!navigate) return;

    id && mutation.mutate({ id, name, description, isActive });
  };

  const handleCancel = () => {
    nativeNavigate(-1);
  };

  /**
   * Render
   */
  return (
    <Form
      department={{ name, description, isActive }}
      setForm={setForm}
      okText={locale.en.common.button.update}
      onOk={handleSubmit}
      cancelText={locale.en.common.button.cancel}
      onCancel={handleCancel}
    />
  );
};
